module.exports = __webpack_public_path__ + "static/img/logo_ats.a69791c.png";


//////////////////
// WEBPACK FOOTER
// ./src/customization/SteelOApp/pages/Login/Assets/Img/logo_ats.png
// module id = MGdV
// module chunks = 0